import { RouteObject, Outlet } from "react-router-dom"
import Information from "applications/information/pages/Information"
import TermsOfService from "applications/information/pages/TermsOfService";
import { ProvideAuth } from "hooks/useAuth";
import AuthedUrqlProvider from "providers/AuthedUrqlProvider";
import { Protected } from "utils/auth/protect"

const InformationRoutes: RouteObject[] = [
  {
    path: "information",
    element: (
      <ProvideAuth>
        <AuthedUrqlProvider>
          <Protected>
            <Outlet />
          </Protected>
        </AuthedUrqlProvider>
      </ProvideAuth>
    ),
    children: [
      { index: true, element: <Information /> },
      { path: "terms_of_service", element: <TermsOfService /> },
    ],
  },
]

export default InformationRoutes
